// extracted by mini-css-extract-plugin
export default {"orderShipModal":"styles_orderShipModal__U88qJ"};